document.addEventListener("click", function (e) {
  const link = e.target.closest('a[href="#sample-pack-anchor"]');
  if (!link) return;

  setTimeout(function () {
    const anchor = document.querySelector("#sample-pack-anchor");
    if (!anchor) return;

    const section = anchor.closest("section");
    if (!section) return;

    section.classList.add("gyf-arrival-highlight");

    setTimeout(function () {
      section.classList.remove("gyf-arrival-highlight");
    }, 1000);
  }, 450);
});
